import { Car, Wrench, ClipboardCheck, Hammer, Package, Fuel } from "lucide-react";
import { Reveal } from "./Motion";
import { useContent } from "../context/ContentContext";

const ICONS = [Car, Wrench, ClipboardCheck, Hammer, Package, Fuel];
const ITEMS_DEFAULT = [
  { t: "Occasions & verkoop", d: "Betrouwbare occasions van € 1.000 tot € 30.000, plus de nieuwste Ford-modellen in de showroom." },
  { t: "Onderhoud", d: "Vakkundig onderhoud met de modernste apparatuur door ervaren, deskundige monteurs." },
  { t: "APK-keuring", d: "Snel en betrouwbaar gekeurd, zodat u zorgeloos de weg op kunt." },
  { t: "Schadeherstel", d: "Erkend schadegarant reparateur — schade snel en vakkundig hersteld." },
  { t: "Ford onderdelen & accessoires", d: "Originele Ford-onderdelen en accessoires om uw auto helemaal van u te maken." },
  { t: "AVIA Tankstation", d: "Een bediend AVIA-tankstation op locatie — servicegericht, net als u van ons gewend bent." },
];

export const Services = () => {
  const { get } = useContent();
  const items = get("diensten.items", ITEMS_DEFAULT);
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24" data-testid="services-section">
      <Reveal>
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-primary">{get("diensten.eyebrow", "Onze diensten")}</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-5xl mt-4 max-w-2xl leading-[1.05]">
          {get("diensten.title", "Alles voor uw Ford onder één dak")}
        </h2>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
        {items.map((s, i) => {
          const Icon = ICONS[i] || Car;
          return (
            <Reveal key={i} delay={(i % 3) * 0.06} className="bg-background p-8 group hover:bg-surface transition-colors">
              <Icon size={30} className="text-primary" strokeWidth={1.5} />
              <h3 className="font-display font-bold text-xl mt-5">{s.t}</h3>
              <p className="text-text-muted text-sm mt-2 leading-relaxed">{s.d}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
